import React from 'react';
import PropTypes from 'prop-types';
import { FrontendApiConfigProvider } from '@edreamsodigeo/frontend-api-client';
import schema from '@edreamsodigeo/support-area-graphqls';
export const BFFSupportAreaProvider = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(FrontendApiConfigProvider, {
    graphQLEndpoint: "/support-area-bff/service/graphql",
    schema: schema
  }, children);
};
BFFSupportAreaProvider.propTypes = {
  children: PropTypes.node.isRequired
};